import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
//import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LoginComponent } from './auth/login/login.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { EffectsModule } from '@ngrx/effects';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreRouterConnectingModule, routerReducer } from '@ngrx/router-store';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
//import { FooterComponent } from './common/components/footer/footer.component';
//import { PageContentComponent } from './common/components/page-content/page-content.component';
//import { StickyFooterComponent } from './common/components/sticky-footer/sticky-footer.component';

import { AuthApiEffects } from './common/store/effects/auth-api.effects';
import { CommonApiEffects } from './common/store/effects/common-api.effects';
import { DealerApiEffects } from './common/store/effects/dealer-api.effects';
import { FilesApiEffects } from './common/store/effects/files-api.effects';
import { RentApiEffects } from './common/store/effects/rent-api.effects';
import { SearchApiEffects } from './common/store/effects/search-api.effects';
import { SearchedCarsStateModule } from './common/store/state/app.state';
import { KeepApiEffects } from './common/store/effects/keep-api.effects';
import { BuyApiEffects } from './common/store/effects/buy-api.effects';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializer } from 'src/utils/app-init';
import { AdminAuthComponent } from './auth/admin/admin.component';
import { ManagerComponent } from './auth/manager/manager.component';
import { AccessDeniedComponent } from './auth/access-denied/access-denied.component';
import { JwtInterceptor } from './auth/interceptors/jwt-interceptor';
import { CarRefApiEffects } from './common/store/effects/carref-api.effects';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { AuthConstants, AuthUrls } from './auth/auth.constants';
import { KeycloakAuthService } from './auth/keycloak-auth.service';
import { NumberDialogComponent } from './public/common/components/number-dialog/number-dialog.component';
import { StickyFooterComponent } from './public/common/components/sticky-footer/sticky-footer.component';
import { FooterComponent } from './public/common/components/footer/footer.component';
import { PageContentComponent } from './public/common/components/page-content/page-content.component';
import { GoogleMapsModule } from '@angular/google-maps';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MaterialModules } from './material.module';
import { DealerMenuComponent } from './sessions/common/dealer-menu/dealer-menu.component';

function initializeKeycloak(keycloakService: KeycloakService) {
  return () => keycloakService.init({
                                      config: {
                                          url: AuthUrls.AUTH_BASE_URL,
                                          realm: AuthConstants.REALM,
                                          clientId: AuthConstants.CLIENT_ID
                                      },
                                      initOptions: {
                                        pkceMethod: AuthConstants.PKCE_METHOD, 
                                        // must match to the configured value in keycloak
                                        redirectUri: AuthUrls.AUTH_REDIRECT_BASE_URL+'/login',   
                                        // this will solve the error 
                                        checkLoginIframe: false
                                      }});
}

@NgModule({ 
        declarations: [
            AppComponent,
            PageContentComponent,
            FooterComponent,
            LoginComponent,
            ForgotPasswordComponent,
            AccessDeniedComponent,
            ManagerComponent,
            AdminAuthComponent
            /**/
        ],
        bootstrap: [AppComponent], 
        imports: [
            BrowserModule,
            BrowserAnimationsModule,
            AppRoutingModule,
            ReactiveFormsModule,
            FormsModule,
            MaterialModules,
            GoogleMapsModule,
            MatDatepickerModule,
            MatNativeDateModule,
            //StoreModule.forRoot({}),
            //StoreDevtoolsModule.instrument({ maxAge: 5 }),
            SearchedCarsStateModule,
            KeycloakAngularModule, //keycloak
            //StoreModule.forRoot({}, {}),
            StoreModule.forRoot({ router: routerReducer }),
            StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: !isDevMode() }),
            EffectsModule.forRoot([
                AuthApiEffects,
                DealerApiEffects,
                CarRefApiEffects,
                SearchApiEffects,
                FilesApiEffects,
                BuyApiEffects,
                RentApiEffects,
                KeepApiEffects,
                CommonApiEffects
            ]),
            StoreRouterConnectingModule.forRoot(),
            CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),

            NumberDialogComponent,
            StickyFooterComponent,
            DealerMenuComponent
        ], 
        providers: [
            MatDatepickerModule,
            {
                provide: APP_INITIALIZER,
                //useFactory: initializer,
                //useFactory: initializeKeycloak,
                useFactory: (authService: KeycloakAuthService) => () => authService.init(),
                //deps: [KeycloakService],
                deps: [KeycloakAuthService],
                multi: true,
            },
            //interceptors
            // {
            //   provide: HTTP_INTERCEPTORS,
            //   useClass: JwtInterceptor,
            //   multi: true
            // },
            {
                provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
                useValue: { appearance: 'outline' }
            },
            provideHttpClient(withXhr(), withInterceptorsFromDi())
        ] 
    })
export class AppModule {  }
